import { render, staticRenderFns } from "./AppTabBar.vue?vue&type=template&id=b915f886&"
import script from "./AppTabBar.vue?vue&type=script&lang=js&"
export * from "./AppTabBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports